export default __webpack_public_path__ + "static/media/day1.d3420c41.png";